import { IonItem, IonLabel, IonList, IonRadio, IonRadioGroup } from '@ionic/react'
import React, { BaseSyntheticEvent } from 'react'
import { IServiceDetail } from '../store/serviceSelection.types'
import { setService } from '../../user/store/user.actions'
import { useDispatch, useSelector } from 'react-redux'
import { getUserSelector } from '../../user/selectors'
import { getServicesSelector } from '../selectors'
import { resetShiftStartup, setName } from '../../crew/store/crew.actions'
import Logger from '../../../services/logger.service'
import { resetConfig } from '../../configurations/store/configurations.actions'

const ServiceList: React.FC = (): JSX.Element => {
  const dispatch = useDispatch()
  const user = useSelector(getUserSelector)
  const services = useSelector(getServicesSelector)
  const { userId, serviceId } = user

  const serviceOnClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    const label = e.target.attributes.getNamedItem('data-label')?.value
    if (!e.currentTarget.value) return
    if (serviceId !== e.currentTarget.value) {
      dispatch(resetShiftStartup())
      dispatch(resetConfig())
      dispatch(setName())
    }
    if (e.currentTarget.value) {
      const selectedServiceIdValue = e.currentTarget.value + ''

      Logger.info(`User: ${userId} navigating into service: '${label}' (S${serviceId})`)

      localStorage.setItem(`${userId}:serviceId`, selectedServiceIdValue)
      localStorage.setItem(`${userId}:serviceName`, label)
      dispatch(setService(selectedServiceIdValue, label))
    }
  }

  return (
    <IonList>
      <IonRadioGroup value={serviceId} onClick={serviceOnClick}>
        {services.map((service: IServiceDetail) => (
          <IonItem key={service.id}>
            <IonLabel>{service.name}</IonLabel>
            <IonRadio
              slot='start'
              value={service.id}
              data-label={service.name}
              data-testid={service.name}
              onChange={serviceOnClick}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  serviceOnClick(e)
                }
              }}
            />
          </IonItem>
        ))}
      </IonRadioGroup>
    </IonList>
  )
}

export default ServiceList
